import React from 'react';
import UnknownDumbView from '../../../DeviationViews/Dumbo/Unknown';
import s from './Unknown.scss';
const UnknownThumbReactView = ({ width, height, deviation })=>/*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(UnknownDumbView, {
        width: width,
        height: height,
        deviation: deviation
    }));
UnknownThumbReactView.displayName = 'UnknownThumbReactView';
export default UnknownThumbReactView;

//# sourceMappingURL=Unknown.js.map